export function PageHeader({ overline, title, children }) {
  return (
    <div className="border-b border-border px-8 py-6 flex items-end justify-between gap-4 flex-wrap">
      <div>
        {overline && <div className="overline text-accent mb-2">{overline}</div>}
        <h1 className="font-heading font-black text-2xl sm:text-3xl tracking-tight">{title}</h1>
      </div>
      <div className="flex items-center gap-2">{children}</div>
    </div>
  );
}

const STATUS = {
  request: { label: "Permintaan", cls: "bg-sky-500/15 text-sky-700 active-glow" },
  draft: { label: "Draft", cls: "bg-secondary text-muted-foreground" },
  sent: { label: "Terkirim", cls: "bg-primary/12 text-primary" },
  negotiating: { label: "Negosiasi", cls: "bg-accent/15 text-accent active-glow" },
  accepted: { label: "Disetujui", cls: "bg-emerald-500/15 text-emerald-700" },
  rejected: { label: "Ditolak", cls: "bg-destructive/12 text-destructive" },
  invoiced: { label: "Invoiced", cls: "bg-violet-500/15 text-violet-700" },
  issued: { label: "Diterbitkan", cls: "bg-primary/12 text-primary" },
  paid: { label: "Lunas", cls: "bg-emerald-500/15 text-emerald-700" },
  expired: { label: "Kedaluwarsa", cls: "bg-orange-500/15 text-orange-700" },
  overdue: { label: "Jatuh Tempo", cls: "bg-destructive/12 text-destructive" },
  void: { label: "Void", cls: "bg-secondary text-muted-foreground" },
};

export function StatusBadge({ status }) {
  const s = STATUS[status] || { label: status, cls: "bg-secondary text-muted-foreground" };
  return (
    <span className={`inline-block px-2 py-0.5 rounded-sm text-xs font-mono uppercase tracking-wide ${s.cls}`}>
      {s.label}
    </span>
  );
}
